<template>
  <div class="express-container">
    <ExpressRules v-if="isReload"></ExpressRules>
  </div>
</template>

<script>
import ExpressRules from '@/components/base/express-rules'
export default {
  components: {
    ExpressRules
  },

  data() {
    return {
      oldPath: '',
      isReload: true
    }
  },

  // watch: {
  //   $route(to) {
  //     console.log(`oldPath:${this.oldPath}`, `toPath:${to.path}`);
  //     if (this.oldPath !== to.path) {
  //       this.oldPath = to.path
  //       this.isReload = false
  //       this.$nextTick(() => {
  //         this.isReload = true
  //       })
  //     }
  //   }
  // },

  created() {
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.express-container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
